export enum Rotate {
	TOP = 'TOP',
	RIGHT = 'RIGHT',
	BOTTOM = 'BOTTOM',
	LEFT = 'LEFT',
}

export const rotateClass: Record<Rotate, string> = {
	[Rotate.TOP]: 'rotate-180',
	[Rotate.RIGHT]: '-rotate-90',
	[Rotate.BOTTOM]: 'rotate-0',
	[Rotate.LEFT]: 'rotate-90',
};
interface ArrowSVGProps {
	fill?: string;
	rotate?: Rotate;
	animation?: boolean;
	width?: number;
	height?: number;
}

export default function ArrowSVG({ fill = '#7F8FA4', rotate = Rotate.TOP, animation = false, width = 24, height = 24 }: ArrowSVGProps) {
	return (
		<svg width={width} height={height} className={`${rotateClass[rotate]} ${animation && 'duration-300'}`} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 13.9497L17.4444 8.99999L19 10.4142L12 16.7782L5 10.4142L6.55556 8.99999L12 13.9497Z'
				fill={fill}
			/>
		</svg>
	);
}
